import { type Model } from '@kfiroo/backgammon-core'
import { type DocumentReference, setDoc } from 'firebase/firestore'

import { PersistenceError } from './PersistenceError'

/** Writes the whole game model. Rejects with PersistenceError on failure. */
export interface GameRepository {
  save(model: Model): Promise<void>
}

export function createFirestoreGameRepository(
  ref: DocumentReference,
  newRequestId: () => string = () => crypto.randomUUID(),
): GameRepository {
  return {
    async save(model) {
      try {
        await setDoc(ref, { ...model, _meta: { requestId: newRequestId() } })
      } catch (err) {
        throw new PersistenceError('Failed to save the game', err)
      }
    },
  }
}
